//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { folderCopyApi, folderDirListApi, folderMoveAllApi, folderMoveApi, folderSpaceEntAllMoveApi, folderSpaceEntCopyApi, folderSpaceEntDirApi, folderSpaceEntMoveApi, folderSpaceListApi } from '@/api/cloud';
export default {
  name: 'MoveDialog',
  props: {
    moveData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      name: '1',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      fileId: null,
      activeIndex: '1',
      formData: {
        type: null
      }
    };
  },
  methods: {
    menuList: function menuList() {
      if (this.moveData.type <= 2 || this.moveData.type === 5) {
        this.name = '1';
        this.activeIndex = '1';
        this.getFolderDirList();
      } else {
        // 企业空间
        this.name = '2';
        this.activeIndex = '2';
        this.getFolderSpaceEntDir();
      }
    },
    // 我的空间
    getFolderDirList: function getFolderDirList() {
      var _this = this;
      folderDirListApi().then(function (res) {
        if (res.data !== undefined) {
          _this.treeData = res.data;
        }
      });
    },
    // 企业空间
    getFolderSpaceEntDir: function getFolderSpaceEntDir() {
      var _this2 = this;
      folderSpaceEntDirApi().then(function (res) {
        _this2.treeData = res.data;
      });
      // var folder = []
      // var arr = []
      // folderSpaceListApi().then((data) => {
      //   folder = data.data
      //   if (folder.length > 0) {
      //     folder.map((value, index) => {
      //       arr.push({
      //         id: value.id,
      //         name: value.name,
      //         pid: value.pid,
      //         icon: '1'
      //       })
      //       folderSpaceEntDirApi(value.id).then((res) => {
      //         if (res.data !== undefined) {
      //           arr[index].children = res.data
      //         } else {
      //           arr[index].children = []
      //         }
      //       })
      //     })
      //     this.$nextTick(() => {
      //       setTimeout(() => {
      //         this.treeData = arr
      //       }, 1000)
      //     })
      //   } else {
      //     this.treeData = []
      //   }
      // })
      // console.log(this.treeData, '树形结构')
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
      this.menuList();
    },
    handleClick: function handleClick(node, data) {
      this.fileId = node.id;
    },
    handleTabClick: function handleTabClick(e) {
      if (this.activeIndex !== this.name) {
        if (this.name == 1) {
          this.getFolderDirList();
        } else {
          this.getFolderSpaceEntDir();
        }
      }
      this.activeIndex = e.name;
    },
    handlerEmit: function handlerEmit() {
      this.$emit('handlerMove', this.formData);
    },
    handleSave: function handleSave() {
      var _this3 = this;
      if (this.fileId === null) {
        var str = '';
        if (this.moveData.type <= 4) {
          str = '选择移动的文件夹';
        } else {
          str = '选择复制的文件夹';
        }
        this.$message.error(str);
      } else if (this.fileId === this.id) {
        var _str = '';
        if (this.moveData.type <= 4) {
          _str = '移动的文件夹不能一样';
        } else {
          _str = '复制的文件夹不能一样';
        }
        this.$message.error(_str);
      } else {
        if (this.moveData.type === 1) {
          // 我的空间单个移动
          folderMoveApi(this.moveData.id, {
            to_id: this.fileId
          }).then(function (res) {
            _this3.formData.type = 1;
            _this3.handlerEmit();
            _this3.handleClose();
          });
        } else if (this.moveData.type === 2) {
          // 我的空间批量移动
          var data = {
            id: this.moveData.id,
            to_id: this.fileId
          };
          folderMoveAllApi(data).then(function (res) {
            _this3.formData.type = 2;
            _this3.handlerEmit();
            _this3.handleClose();
          });
        } else if (this.moveData.type === 3) {
          // 企业空间单个移动
          folderSpaceEntMoveApi(this.moveData.fid, this.moveData.id, {
            to_id: this.fileId
          }).then(function (res) {
            _this3.formData.type = 3;
            _this3.handlerEmit();
            _this3.handleClose();
          });
        } else if (this.moveData.type === 4) {
          // 企业空间批量修改
          var _data = {
            id: this.moveData.id,
            to_id: this.fileId
          };
          folderSpaceEntAllMoveApi(this.moveData.fid, _data).then(function (res) {
            _this3.formData.type = 4;
            _this3.handlerEmit();
            _this3.handleClose();
          });
        } else if (this.moveData.type === 5) {
          // 我的空间复制文件

          var _data2 = {
            to_id: this.fileId,
            fid: this.moveData.fid
          };
          folderCopyApi(this.moveData.id, _data2).then(function (res) {
            _this3.formData.type = 5;
            _this3.handlerEmit();
            _this3.handleClose();
          });
        } else if (this.moveData.type === 6) {
          // 企业空间复制文件
          var _data3 = {
            to_id: this.fileId,
            fid: this.moveData.fid
          };
          folderSpaceEntCopyApi(this.moveData.fid, this.moveData.id, _data3).then(function (res) {
            _this3.formData.type = 6;
            _this3.handlerEmit();
            _this3.handleClose();
          });
        }
      }
    }
  }
};